module.exports = __webpack_public_path__ + "static/media/gc-hotel-room2.61b97259.png";